import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import styles from "./style.module.css";

import Loader from "../../../Utility/Loader";
import Card from "../../components/card/Card";
import Sidebar from "../../components/sidebar/sidebar";
import { fetchDataById } from "../../../../actions/Profile";

export default function ProfileDetails() {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      try {
        const data = await fetchDataById(params?.id);
        if (data) {
          setProfile(data);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [params.id]);

  return (
    <Sidebar>
      <div className={styles.container}>
        {loading ? (
          <Loader />
        ) : profile ? (
          <Card show likes={true} {...profile} />
        ) : (
          <div className={styles.chatPlaceholder}>
            <p>No record Found</p>
          </div>
        )}
      </div>
    </Sidebar>
  );
}
